var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1958_3029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 9.99996L9.1665 11.6666L12.9165 7.91663M6.11131 3.18221C6.78117 3.12875 7.4171 2.86534 7.92856 2.42948C9.12211 1.41234 10.8776 1.41234 12.0711 2.42948C12.5826 2.86534 13.2185 3.12875 13.8884 3.18221C15.4516 3.30695 16.6928 4.54825 16.8176 6.11143C16.871 6.78129 17.1345 7.41722 17.5703 7.92868C18.5875 9.12223 18.5875 10.8777 17.5703 12.0712C17.1345 12.5827 16.871 13.2186 16.8176 13.8885C16.6928 15.4517 15.4516 16.693 13.8884 16.8177C13.2185 16.8712 12.5826 17.1346 12.0711 17.5704C10.8776 18.5876 9.12211 18.5876 7.92856 17.5704C7.4171 17.1346 6.78117 16.8712 6.11131 16.8177C4.54812 16.693 3.30683 15.4517 3.18208 13.8885C3.12863 13.2186 2.86522 12.5827 2.42935 12.0712C1.41222 10.8777 1.41222 9.12223 2.42935 7.92868C2.86522 7.41722 3.12863 6.78129 3.18208 6.11143C3.30683 4.54825 4.54812 3.30695 6.11131 3.18221Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1958_3029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckVerified);
export default __webpack_public_path__ + "static/media/ic_check_verified.f657d42e393eaf4e21adec89f547ad00.svg";
export { ForwardRef as ReactComponent };